import React from 'react';
import { Form, Upload, Button, DatePicker, Radio, Typography, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Title } = Typography;

const Step3 = ({ form, next, prev, getValueFromEvent }) => {

  // Function to check the file type and restrict it to PDF, JPG, or PNG
  const beforeUpload = (file) => {
    const isAllowedType = file.type === 'application/pdf' || file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isAllowedType) {
      message.error('You can only upload PDF, JPG, or PNG files!');
    }
    return isAllowedType ? true : Upload.LIST_IGNORE;
  };

  return (
    <div>
      <Title level={2}>Your License</Title>
      <Form form={form} layout="vertical" onFinish={next}>
        <Form.Item 
          name="fullLicenseNSW" 
          label="Have you had your Full License in NSW for more than 1 year" 
          rules={[{ required: true }]}
        >
          <Radio.Group>
            <Radio value="yes">Yes</Radio>
            <Radio value="no">No</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item 
          name="licenseExpiry" 
          label="License Expiry" 
          rules={[{ required: true }]}
        >
          <DatePicker format="DD-MM-YYYY" />
        </Form.Item>

        {/* <Form.Item 
          name="anotherState" 
          label="If you have not had your license in NSW for more than 1 year, but had your license in another Australian State or Territory please attach your driving history" 
          valuePropName="fileList" 
          getValueFromEvent={(info) => {
            if (Array.isArray(info)) {
              return info;
            }
            const { fileList } = info;
            return fileList;
          }}
          rules={[{ required: true }]}
        >
          <Upload beforeUpload={beforeUpload} listType="picture" maxCount={1}>
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item> */}
        <Form.Item 
          name="previousState" 
          // label="Please attach a photo of your Drivers License from previous state" 
          label="If you have not had your license in NSW for more than 1 year, but had your license in another Australian State or Territory please attach your driving history" 
          valuePropName="fileList" 
          getValueFromEvent={(info) => {
            if (Array.isArray(info)) {
              return info;
            }
            const { fileList } = info;
            return fileList;
          }}
          rules={[{ required: true }]}
        >
          <Upload beforeUpload={beforeUpload} listType="picture" maxCount={1}>
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item>
        <Form.Item 
          name="drivingHistory" 
          label="Please attach a copy of your NSW Driving History Report" 
          valuePropName="fileList" 
          getValueFromEvent={(info) => {
            if (Array.isArray(info)) {
              return info;
            }
            const { fileList } = info;
            return fileList;
          }}
          rules={[{ required: true }]}
        >
          <Upload beforeUpload={beforeUpload} listType="picture" maxCount={1}>
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item>

        <Form.Item 
          name="licenseFront" 
          label="Photo of the front of your NSW license" 
          valuePropName="fileList" 
          getValueFromEvent={(info) => {
            if (Array.isArray(info)) {
              return info;
            }
            const { fileList } = info;
            return fileList;
          }}
          rules={[{ required: true }]}
        >
          <Upload beforeUpload={beforeUpload} listType="picture" maxCount={1}>
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item>
        <Form.Item 
          name="licenseRear" 
          label="Photo of the rear of your NSW license" 
          valuePropName="fileList" 
          getValueFromEvent={(info) => {
            if (Array.isArray(info)) {
              return info;
            }
            const { fileList } = info;
            return fileList;
          }}
          rules={[{ required: true }]}
        >
          <Upload beforeUpload={beforeUpload} listType="picture" maxCount={1}>
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item>
        <Button style={{ marginRight: 20 }} type="primary" onClick={prev}>Back</Button>
        <Button type="primary" htmlType="submit">Next</Button>
      </Form>
    </div>
  );
};

export default Step3;
